import { authenticatedFetch } from '../authenticatedFetch';

let entitlementsPromise;

export function getEntitlements() {
  return entitlementsPromise;
}

export function refetchEntitlements() {
  return (entitlementsPromise = authenticatedFetch(`/entitlements`, {
    method: 'POST',
  }).then((response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw Error(
        `Entitlements API responded with HTTP status ${response.status}`
      );
    }
  }));
}
